const ko = {
  // Navigation
  nav_home: "집",
  nav_explore: "탐구하다",
  nav_workspace: "작업공간",
  ws_videos: "비디오",
  ws_untitled: "제목 없는 동영상",
  // A generation that failed. The card carries these until it is dismissed.
  ws_failed_title: "동영상 실패",
  ws_failed_refunded: "귀하의 크레딧이 반환되었습니다",
  ws_failed_dismiss: "해고하다",
  ws_failed_retry: "다시 시도하세요",
  ws_failed_retrying: "시작 중…",
  ws_failed_banner_one: "동영상을 생성하지 못했습니다.",
  ws_failed_banner_many: "{n}개의 동영상이 실패했습니다.",
  ws_failed_banner_body: "청구된 금액은 없습니다. 크레딧이 귀하의 계정으로 반환되었습니다. 다시 시도하거나 다른 주제를 선택하세요.",
  ws_empty_title: "아직 아무것도 없습니다.",
  ws_empty_body: "귀하가 제작하는 모든 동영상이 최신 항목부터 여기에 표시됩니다.",
  ws_generate: "생성하다",
  ws_composer_placeholder: "강의 설명하기\u2026",
  ws_placeholder_hw: "과제 이름을 지정하세요… (선택 사항)",
  ws_placeholder_lecture: "강의 이름을… (선택 사항)",
  ws_placeholder_self_study: "무엇을 공부하고 싶나요?",
  nav_search: "동영상 검색...",
  nav_search_yours: "동영상 검색...",
  nav_notifications: "알림",
  nav_mark_all_read: "모두 읽은 것으로 표시",
  nav_no_notifications: "아직 알림이 없습니다",
  nav_no_notifications_sub: "동영상이 준비되면 알려드리겠습니다.",
  nav_upgrade: "치받이",
  nav_billing: "청구",
  nav_settings: "설정",
  nav_contact: "문의하기",
  nav_api: "API",
  nav_sign_out: "로그아웃",
  nav_just_now: "방금",
  nav_minutes_ago: "{n}분 전",
  nav_hours_ago: "{n}시간 전",
  nav_days_ago: "{n}일 전",
  nav_used_this_month: "이번 달에 사용된 {used} 중 {cap}",
  // locale file, and this one is the obvious thing to reach for if a weekly bucket returns.
  nav_used_today: "이번 주에 {used} 중 {limit} 사용됨",
  nav_free_daily: "주당 4개의 무료 동영상",
  // Settings
  settings_title: "설정",
  settings_profile: "윤곽",
  settings_change_avatar: "아바타 변경",
  settings_cancel: "취소",
  settings_choose_wizard: "마법사를 선택하세요",
  settings_display_name: "표시 이름",
  settings_your_name: "당신의 이름",
  settings_save: "구하다",
  settings_saving: "절약...",
  settings_saved: "저장됨",
  settings_save_failed: "저장하지 못했습니다.",
  settings_email: "이메일",
  settings_notifications: "알림",
  settings_email_notif: "이메일 알림",
  settings_email_notif_desc: "이메일을 통해 업데이트 및 공지사항을 받아보세요",
  settings_language: "언어",
  settings_language_desc: "앱 및 비디오 내레이션의 언어를 선택하세요.",
  settings_data_title: "귀하의 데이터",
  settings_data_desc: "프로필, 동영상, 강좌, 세션, 지원 메시지 등 계정과 관련된 개인 데이터의 사본을 다운로드하세요. 내부 시스템 로그 및 파생된 처리 데이터는 포함되지 않습니다.",
  settings_data_download: "내 데이터 다운로드",
  settings_data_exporting: "준비 중…",
  settings_danger: "위험지대",
  settings_delete_account: "계정 삭제",
  settings_delete_desc: "귀하의 계정 및 모든 관련 데이터를 영구적으로 삭제하십시오. 이 작업은 취소할 수 없습니다.",
  settings_delete_confirm: "이렇게 하면 귀하의 계정과 모든 데이터가 영구적으로 삭제됩니다. 확인하려면 {keyword}를 입력하세요.",
  settings_delete_placeholder: "확인하려면 \"DELETE\"를 입력하세요.",
  settings_permanently_delete: "영구 삭제",
  settings_deleting: "삭제 중...",
  explore_watch_now: "지금 시청하기",
  // One pair of strings per scene; the eyebrow and the button are shared.
  explore_no_preview: "미리보기 없음",
  explore_no_videos: "아직 사용할 수 있는 동영상이 없습니다. 곧 다시 확인해 보세요.",
  explore_featured_courses: "주요 강좌",
  course_lesson_count: "{n, plural, one {# lesson} other {# lessons}}",
  course_back_to_explore: "탐색으로 돌아가기",
  course_not_found: "이 강좌는 이용할 수 없습니다.",
  // Home Page
  home_hero: "무엇이든 배우고,",
  home_hero_accent: "시각적으로",
  home_placeholder: "무엇을 배우고 싶거나 해결하고 싶나요?",
  home_extracting: "질문 추출 중...",
  home_videos_generated: "{n, plural, other {# 비디오}}가 생성됩니다",
  home_credits: "{n, plural, other {# 크레딧}}",
  home_remaining: "이번달 남은",
  home_enter_prompt: "배우고 싶은 내용이나 해결하고 싶은 내용을 입력해주세요",
  home_popular: "인기 레슨",
  home_from_community: "커뮤니티에서",
  home_community_sub: "학생들이 무엇을 만들고 있는지 확인하세요.",
  home_tips_label: "마법사 마법사에게서",
  home_tips_title: "팁과 요령",
  home_tip1_title: "구체적으로 말하라",
  home_tip1_desc: "전체 주제를 입력하지 마세요. 하나의 아이디어, 하나의 개념, 하나의 질문을 선택하세요.",
  home_tip1_example: "진핵 세포에서 DNA 복제가 작동하는 방식",
  home_tip2_title: "누구를 위한 것인지 말해 보세요",
  home_tip2_desc: "중학교 설명은 대학 강의와 전혀 다르게 보입니다.",
  home_tip2_example: "방금 대수학을 배운 사람을 위해 도함수를 설명하세요.",
  home_tip3_title: "마기에게 원하는 것을 말해주세요",
  home_tip3_desc: "예, 단계별, 실제 적용 사례를 말만 하면 Magi가 따라갈 것입니다.",
  home_tip3_example: "실제 사례와 요약을 통한 물 순환",
  home_tip_try: "다음과 같은 것을 시도해보세요",
  home_proven_social: "인스타그램에서 우리를 팔로우하세요",
  home_ig_desc_1: "위에",
  home_ig_followers: "팔로어 55,000명",
  home_ig_desc_2: "매일 Instagram에서 수학 및 과학 동영상을 시청하세요. 이 릴은 여기에서 사용하는 것과 동일한 엔진으로 만들어졌습니다.",
  home_view_profile: "프로필 보기",
  home_subscribe_now: "지금 구독하세요",
  home_sub_monthly: "월간 간행물",
  home_sub_yearly: "매년",
  // goes false the moment either price moves, on the surface where that matters most.
  home_sub_yearly_save: "{pct}% 절감",
  home_sub_per_month: "/ 월",
  home_sub_billed_monthly: "매달 ${amount} 청구됨",
  home_sub_processing: "처리 중...",
  home_sub_no_commitment: "헌신이 없습니다. 언제든지 취소하세요.",
  home_sub_secured: "스트라이프로 보호",
  home_sub_headline: "{plan}으로 더 많은 혜택을 누리세요",
  home_sub_due_now: "지금 마감",
  home_sub_trial_label: "{days}일 전체 액세스",
  // choosing the plan directly is owed exactly what a trialist is owed.
  home_sub_monthly_terms: "이번 달 ${amount}개의 동영상에 대해 오늘 {n}가 청구됩니다. 먼저 취소하지 않는 한 {date}에 ${amount}/월로 갱신됩니다. 결제에서 언제든지 취소하세요.",
  // frequency, states that it happens automatically, and says where to cancel.
  home_sub_trial_terms: "오늘 ${trial}일간 전체 액세스에 대한 {days}의 요금이 청구됩니다. 최대 {n}개의 동영상이 가능합니다. 평가판은 ${trial}에 계속되지 않습니다. — {date}에 자동으로 월 {planName}(${plan} 동영상)의 {full}이 되며, 이후 취소할 때까지 ${plan}이(가) 매달 청구됩니다. 언제든지 결제를 취소할 수 있습니다.",
  home_sub_card: "신용카드 또는 직불카드",
  home_sub_billed_once_yearly: "1년에 한 번 ${amount} 청구됨",
  home_sub_billed_trial: "${amount}일 동안 {days} 청구 후 매달 ${renews}에 갱신",
  home_sub_switch_plan: "대신 {plan}을(를) 찾고 계시나요?",
  home_sub_replaces_plan: "귀하의 {plan} 계획을 대체합니다. 청구 날짜는 동일하게 유지됩니다. 위로 올라가면 지금 차액이 청구되고, 아래로 올라가면 다음 갱신부터 시작됩니다.",
  home_sub_change_now: "이제 {plan} 플랜입니다 — 차액 {amount}이(가) 청구되었습니다.",
  home_sub_change_later: "{date}에 {plan} 플랜으로 변경됩니다. 오늘은 청구되지 않습니다.",
  // the allowance changed; this one cannot.
  home_sub_feature_videos_n: "매월 {n}개의 비디오",
  // Pricing Page
  pricing_title: "계획을 업그레이드하세요",
  pricing_monthly: "월간 간행물",
  pricing_yearly: "매년",
  pricing_save: "17% 할인",
  pricing_best_value: "최고의 가치",
  pricing_your_plan: "현재 계획",
  pricing_get_started: "시작하기",
  pricing_processing: "처리 중...",
  pricing_per_month: "/월",
  pricing_billed_yearly: "${amount}/년 청구됨",
  pricing_videos_month: "{n, plural, other {# 비디오}}/월",
  pricing_manage_cancel: "관리 또는 취소",
  pricing_manage_unavailable: "관리할 구독을 찾지 못했습니다. 문의해 주시면 처리해 드리겠습니다.",
  pricing_opening: "열기...",
  billing_autorenew_monthly: "취소할 때까지 ${amount}/월로 자동 갱신됩니다.",
  billing_autorenew_yearly: "취소할 때까지 연간 ${amount}씩 자동으로 갱신됩니다.",
  billing_autorenews_on: "{date} 자동 갱신 · 언제든지 취소",
  pricing_secured: "스트라이프로 보호",
  pricing_login_required: "구독하려면 로그인하세요.",
  pricing_auth_error: "사용자 인증 오류입니다. 로그아웃했다가 다시 로그인해 보세요.",
  pricing_feature_pdf: "PDF 및 이미지 추출",
  pricing_feature_quality: "더 높은 품질의 모델",
  pricing_feature_speed: "더 빠른 생성 시간",
  pricing_feature_study: "학습 세션",
  pricing_free_hint: "현재 무료 요금제 이용 중",
  // Billing Page
  billing_title: "청구",
  billing_current_plan: "현재 계획",
  billing_payment_failed_title: "계획이 일시중지되었습니다.",
  billing_payment_failed_body: "{amount}을(를) 징수할 수 없어 귀하의 계획이 일시중지되었습니다. 다시 시작하려면 카드를 업데이트하세요. 계속해서 다시 시도하겠습니다.",
  billing_payment_failed_cta: "결제 수정",
  billing_change_plan: "계획 변경",
  billing_invoices: "송장",
  billing_loading: "송장 로드 중...",
  billing_no_invoices: "아직 인보이스가 없습니다.",
  billing_date: "날짜",
  billing_amount: "양",
  billing_status: "상태",
  billing_invoice: "송장",
  billing_view: "보다",
  // Contact Page
  contact_title: "문의하기",
  contact_placeholder: "어떻게 도와드릴까요?",
  contact_sent_desc: "최대한 빨리 연락드리겠습니다.",
  contact_signin: "지원팀에 문의하려면 로그인하세요.",
  // Generation Queue
  queue_title: "대기줄",
  queue_active: "{n} 활성",
  queue_generating: "{n} 생성 중",
  queue_ready: "시청 준비 완료",
  queue_in_queue: "대기열에서 기다리는 중...",
  queue_almost_ready: "거의 준비됐어요...",
  queue_seconds_left: "{n}남음",
  queue_minutes_left: "{m}m {s}초 남음",
  queue_watch_now: "지금 시청하기",
  queue_waiting: "대기열에서 기다리고 있습니다...",
  queue_empty: "대기열에 동영상이 없습니다.",
  queue_empty_sub: "여기에서 보려면 동영상을 생성하세요.",
  queue_clear: "모두 지우기",
  queue_total: "총 {n}",
  queue_first_time: "동영상을 생성하는 중입니다.",
  queue_first_time_sub: "보통 2분 정도 소요됩니다. 준비가 되면 차임벨 소리가 들립니다.",
  // Session Expired
  session_expired: "세션이 만료되었습니다",
  session_expired_desc: "보안상의 이유로 세션이 만료되었습니다. 계속하려면 다시 로그인하세요.",
  // Cookie Banner
  cookie_text: "당사는 사이트 트래픽을 분석하고 귀하의 경험을 개선하기 위해 쿠키를 사용합니다. 기본적으로 필수 쿠키만 설정됩니다.",
  cookie_learn_more: "자세히 알아보기",
  cookie_accept: "모두 수락",
  cookie_reject: "필수적이지 않은 거부",
  // Create Project Modal
  create_new_project: "새 프로젝트",
  create_extracting: "적출...",
  create_select_problems: "문제 선택",
  create_select_topics: "주제 선택",
  create_new_video: "새 비디오",
  create_new_hw: "새로운 숙제 프로젝트",
  create_new_lecture: "새로운 강의 프로젝트",
  create_new_self_study: "새 프로젝트",
  create_video: "동영상",
  create_homework: "숙제",
  create_lecture: "강의",
  create_self_study: "프로젝트",
  create_video_sub: "비디오 생성",
  create_hw_sub: "숙제 업로드",
  create_lecture_sub: "슬라이드 업로드",
  create_self_study_sub: "주제를 선택하세요",
  create_video_prompt: "영상은 무엇을 설명해야 할까요?",
  create_project_title: "프로젝트 제목",
  create_video_hint: "This will be used as both the title and the prompt for your video.",
  create_drop_hw: "여기에 숙제를 내려놔",
  create_drop_lecture: "Drop your lecture slides here",
  create_file_types: "PDF, PNG, JPG, HEIC",
  // Shown over the composer while a file is being dragged onto it.
  composer_drop_hint: "드롭하여 프로젝트 시작",
  create_reading_hw: "숙제 읽기",
  create_reading_lecture: "강의를 읽고",
  create_finding_problems: "문제를 찾고 추출하는 중...",
  create_finding_topics: "주제 추출 중...",
  create_add_video: "다른 동영상 추가",
  create_add_more_files: "더 많은 파일 추가",
  create_starting: "세대를 시작하는 중...",
  create_generate_video: "동영상 생성 \u00B7 1크레딧",
  create_generate_n: "{n, plural, other {# 비디오}} 생성 \u00B7 {n, plural, other {# 크레딧}}",
  create_create_project: "프로젝트 만들기 \u00B7 {n, plural, other {# 크레딧}}",
  create_no_problems: "어떤 문제도 발견하지 못했습니다. 더 선명한 사진이나 다른 페이지를 사용해 보세요.",
  create_no_topics: "주제를 찾을 수 없습니다. 더 선명한 사진이나 다른 파일을 사용해 보세요.",
  create_error: "문제가 발생했습니다. 다시 시도해 주세요.",
  create_extract_daily_limit: "오늘의 서류는 이게 전부입니다. 내일은 더 많이.",
  create_video_topic_placeholder: "비디오 {n} 주제(예: \"고유값과 고유벡터\"",
  video_share: "공유하다",
  // and made the two indistinguishable.
  video_followup_placeholder: "후속 비디오 생성...",
  video_chip_simpler: "더 간단하게 설명하세요",
  video_chip_harder: "더 어려운 예",
  video_chip_real_world: "실제 사용",
  // spends a credit generating a new one.
  video_ask_title: "이 영상에 대해 물어보세요",
  video_ask_cta: "이것에 대해 채팅",
  video_ask_placeholder: "질문하세요...",
  video_ask_thinking: "생각...",
  video_ask_close: "닫다",
  video_ask_chip_explain: "그 부분을 설명해보세요",
  video_ask_chip_example: "예를 들어보세요",
  video_ask_chip_why: "그게 왜 효과가 있나요?",
  video_ask_limit_reached: "오늘의 질문 한도에 도달했습니다. 내일 재설정됩니다.",
  video_up_next: "다음",
  video_no_suggested: "아직 추천 동영상이 없습니다.",
  video_untitled: "제목 없는 동영상",
  video_created_recently: "최근에 생성됨",
  video_just_now: "방금",
  video_minutes_ago: "{n, plural, other {# 분}} 전",
  video_hours_ago: "{n, plural, other {# 시간}} 전",
  video_days_ago: "{n, plural, other {# 일}} 전",
  video_weeks_ago: "{n, plural, other {# 주}} 전",
  video_months_ago: "{n, plural, other {# 개월}} 전",
  video_years_ago: "{n, plural, other {# 년}} 전",
  video_unknown_date: "날짜를 알 수 없음",
  video_download_error: "문제가 발생했습니다. 다시 시도해 주세요.",
  // Search Results
  search_no_results: "검색결과가 없습니다",
  search_no_results_for: "\"{query}\"에 대한 결과를 찾을 수 없습니다.",
  search_all_videos: "모든 동영상 검색",
  search_enter_term: "동영상을 찾으려면 검색어를 입력하세요.",
  search_retry: "검색 재시도",
  auth_continue_google: "Google로 계속하기",
  // sentence, and the box ships unticked — a pre-ticked box is not consent.
  home_sub_waiver: "바로 액세스를 시작하세요. 나는 이것이 내가 {days}일 동안 철회하고 환불받을 수 있는 권리를 포기한다는 것을 의미한다는 것을 이해합니다.",
  home_sub_waiver_required: "계속하려면 이를 확인해 주세요.",
  home_sub_agree_prefix: "계속하면 다음 내용에 동의하게 됩니다.",
  // floor is 13 — if that clause changes, this string and DIGITAL_CONSENT_AGE move with it.
  auth_min_age: "Magi를 사용하려면 {age}세 이상이어야 합니다.",
  auth_agree_prefix: "로그인하면 다음 내용에 동의하게 됩니다.",
  auth_terms: "서비스 약관",
  auth_and: "그리고",
  auth_privacy: "개인 정보 보호 정책",
  auth_email_optin: "팁과 업데이트를 보내주세요",
  // Auth modal (Google + email/password)
  auth_signin_title: "마기에 로그인",
  auth_signin_desc: "중단한 부분부터 다시 시작하세요.",
  auth_signup_title: "계정 만들기",
  auth_signup_desc: "무료로 시작할 수 있으며 카드가 필요하지 않습니다.",
  auth_or: "또는",
  auth_continue_email: "이메일로 계속하기",
  auth_signing_in: "로그인 중…",
  auth_working: "잠시만…",
  auth_email_placeholder: "이메일 주소",
  auth_password_placeholder: "비밀번호",
  auth_signin_submit: "로그인",
  auth_signup_submit: "계정 만들기",
  auth_no_account: "여기 새로 왔나요?",
  auth_signup_link: "계정 만들기",
  auth_have_account: "이미 계정이 있나요?",
  auth_signin_link: "로그인",
  auth_forgot_password: "비밀번호를 잊으셨나요?",
  auth_reset_title: "비밀번호 재설정",
  auth_reset_desc: "새 링크를 설정할 수 있는 링크를 이메일로 보내드리겠습니다.",
  auth_reset_submit: "재설정 링크 보내기",
  auth_reset_sent: "이메일에서 재설정 링크를 확인하세요.",
  auth_back_to_signin: "로그인으로 돌아가기",
  // Full-screen wall shown to a signed-in account that has not confirmed its address.
  verify_wall_title: "계속하려면 이메일을 확인하세요.",
  verify_wall_desc: "{email}로 확인 링크를 보냈습니다. 클릭한 다음 여기로 돌아오세요.",
  verify_wall_check: "확인했어요",
  verify_wall_checking: "확인 중...",
  verify_wall_still_unverified: "아직 확인되지 않았습니다. 이메일에 있는 링크를 클릭한 후 다시 시도하세요.",
  verify_wall_resend: "링크를 다시 보내세요",
  verify_wall_resent: "전송된. 받은 편지함과 스팸 폴더를 확인하세요.",
  verify_wall_wrong_account: "잘못된 계정인가요? 로그아웃",
  // The screen the confirmation LINK lands on, replacing Firebase's unbranded handler page.
  verify_action_working_title: "이메일 확인 중",
  verify_action_working_desc: "잠시만요.",
  verify_action_done_title: "모든 준비가 완료되었습니다.",
  verify_action_done_desc: "귀하의 이메일이 확인되었습니다. Magi에 오신 것을 환영합니다.",
  verify_action_done_cta: "학습 시작",
  verify_action_failed_title: "해당 링크가 작동하지 않았습니다",
  verify_action_failed_desc: "이미 사용되었거나 만료되었을 수 있습니다. 돌아가서 새로운 것을 보내십시오.",
  verify_action_failed_cta: "Magi로 돌아가기",
  // Wall copy — each surface names what signing in actually gets you
  auth_watch_title: "시청하려면 로그인하세요.",
  auth_watch_desc: "이 비디오를 재생하려면 무료 계정을 만드세요.",
  auth_watch_ready_title: "동영상이 준비되었습니다",
  auth_watch_ready_desc: "시청하려면 로그인하세요. 계정에 저장됩니다.",
  // rather than saying "sign in" twice — the specific ask converts, the generic one nags.
  auth_download_title: "다운로드하려면 로그인하세요.",
  auth_download_desc: "이 비디오를 저장하려면 무료 계정을 만드세요.",
  auth_ask_title: "질문하려면 로그인하세요.",
  auth_ask_desc: "이 비디오에 대해 문의하려면 무료 계정을 만드세요.",
  auth_browse_title: "탐색하려면 로그인하세요.",
  auth_browse_desc: "무료 계정을 만들어 모든 강의를 살펴보세요.",
  auth_workspace_title: "작업을 보려면 로그인하세요.",
  auth_workspace_desc: "귀하의 수업과 프로젝트는 귀하의 계정에 있습니다.",
  auth_generate_title: "계속 만들려면 로그인하세요.",
  auth_generate_desc: "무료 계정은 매일 비디오를 받습니다.",
  video_restricted: "이 동영상은 아직 볼 수 없습니다.",
  // Share sheet
  share_title: "이 영상을 공유하세요",
  share_desc_mobile: "스토리에 게시하거나, 친구에게 보내거나, 링크를 복사하세요.",
  share_desc_desktop: "링크를 복사하거나 동영상을 다운로드하여 휴대폰에서 게시하세요.",
  share_to_apps: "Instagram 등에 공유",
  share_copy_link: "링크 복사",
  share_copied: "링크가 복사되었습니다",
  share_download: "비디오 다운로드",
  share_preparing: "준비 중…",
  share_watermark_note: "공유 비디오에는 magiacademy.com이 포함됩니다.",
  // Welcome Modal (post-signup)
  welcome_title: "마기에 오신 것을 환영합니다",
  welcome_subtitle: "시작하려면 4개의 무료 동영상이 있습니다.",
  welcome_optin_reward: "+1 무료 동영상",
  welcome_continue: "계속하다",
  age_gate_continue: "계속하다",
  age_gate_saving: "절약...",
  // Landing Page
  landing_hero: "주제를 입력하세요.",
  landing_hero2: "비디오 강의를 받으세요.",
  landing_subtitle: "Magi는 어떤 주제라도 몇 분 만에 아름다운 애니메이션과 내레이션이 포함된 비디오로 변환합니다. 촬영도, 편집도, 전문 지식도 필요하지 않습니다.",
  landing_signup_google: "Google에 가입",
  landing_signing_in: "로그인 중...",
  landing_chat_bubble: "GPS는 상대성 이론을 어떻게 사용합니까?",
  landing_stats_title: "전 세계 학습자가 신뢰하는",
  landing_stat_videos: "3,000+",
  landing_stat_videos_desc: "생성된 비디오",
  landing_stat_languages_desc: "언어",
  landing_stat_speed: "~1분",
  landing_stat_speed_desc: "생성 시간",
  landing_feature_lecture_title: "강의 노트를 작성하고 비디오를 받아보세요",
  landing_feature_lecture_desc: "슬라이드나 메모를 업로드하세요. Magi는 각 주제를 꺼내서 모든 주제에 대한 비디오 설명을 생성합니다.",
  landing_feature_hw_title: "숙제가 막혔나요? 업로드하세요.",
  landing_feature_hw_desc: "문제 세트를 삭제하면 Magi가 각 문제를 추출한 다음 단계별 비디오를 통해 솔루션을 안내합니다.",
  landing_feature_chat_title: "시청하는 동안 질문하기",
  landing_feature_chat_desc: "모든 비디오에는 채팅할 수 있는 AI 교사가 함께 제공됩니다. 후속 질문을 하거나, 더 깊은 설명을 듣거나, 더 잘 이해하고 싶은 특정 부분에 대한 새 동영상을 요청하세요.",
  landing_feature_lang_title: "귀하의 언어로 배우십시오",
  landing_feature_lang_desc: "Magi는 영어, 스페인어, 힌디어, 중국어, 일본어 등으로 비디오를 생성합니다. 어떤 언어로든 주제를 입력하고 해당 언어로 완전히 설명된 강의를 받아보세요.",
  landing_cta_title: "몇 초 안에 학습을 시작하세요",
  landing_cta_google: "Google로 계속하기",
  // Onboarding Bubbles
  onboarding_step1: "이것은 챗봇이 아닙니다. 주제를 입력하면 전체 비디오 강의를 생성해 드리겠습니다!",
  onboarding_step2: "아니면 PDF나 사진을 첨부하세요. 모든 문제를 단계별 비디오 솔루션으로 바꿔 드리겠습니다.",
  onboarding_step3: "이동을 누르면 동영상이 대기열에 추가됩니다. 렌더링되는 동안 계속 탐색할 수 있습니다!",
  onboarding_generating: "몇 분 동안 진행되는 강의입니다. 원한다면 계속 찾아보세요. 준비가 되면 바로 여기에 착륙할 거예요.",
  onboarding_skip: "건너뛰다",
  onboarding_next: "다음",
  onboarding_done: "알았어요!",
  // Generating Cards Row
  generating_label: "생성 중",
  // Lecture Session (Self Study)
  lecture_loading: "로드 중...",
  lecture_fallback_title: "강의",
  lecture_building: "빌딩 영상...",
  lecture_building_time: "일반적으로 2~4분 정도 소요됩니다.",
  lecture_failed: "비디오 생성 실패",
  lecture_no_video: "아직 동영상이 없습니다.",
  lecture_followup: "후속 조치",
  lecture_now_playing: "지금 재생 중",
  lecture_tab_videos: "비디오",
  lecture_tab_chat: "채팅",
  lecture_chat_empty: "이 주제에 관해 무엇이든 물어보세요",
  lecture_chat_chip1: "간단하게 설명하세요",
  lecture_chat_chip2: "예를 들어보세요",
  lecture_chat_chip3: "이것이 왜 유용한가요?",
  lecture_chat_placeholder: "이 주제에 대해 물어보세요...",
  lecture_followup_placeholder: "후속 동영상 추가...",
  lecture_chat_error: "죄송합니다. 말씀하신 내용을 처리할 수 없습니다. 다시 시도해 보세요.",
  lecture_chat_generic_error: "문제가 발생했습니다. 다시 시도해 보세요.",
  // Home shortcuts — square cards that jump to the Workspace composer preset to a mode
  home_sc_hw_title: "숙제 PDF",
  home_sc_hw_desc: "문제 세트를 업로드하고 모든 질문에 대해 해결된 비디오를 받으세요.",
  home_sc_lecture_title: "강의 PDF",
  home_sc_lecture_desc: "슬라이드나 노트를 일련의 강의로 전환하세요",
  home_sc_course_title: "강좌 만들기",
  home_sc_course_desc: "하나의 주제에 대한 일련의 수업을 계획하세요.",
  // Misc
  generic_error: "문제가 발생했습니다. 다시 시도해 주세요.",
  loading: "로드 중...",
};

export default ko;
